import React, { useEffect, useMemo, useState } from 'react';
import { Text } from '@applane/react-core-components';
import { ActivityIndicator } from '@applane/react-activity-indicator';
import { View, Storage, Toast } from '../../../app-components';
import { loginAsThisDealer, powerIcon } from '../../../images';
import {
  getUser,
  invoke,
  logout,
  refreshUserToken,
  setUser,
} from '../../../AppServices';
import ScreenHeaderActions from './ScreenHeaderActions';
import headerTheme from './headerTheme';
import { IconButton } from '../../../app-components/buttons/Buttons';
import UserInfo2 from './Actions/UserInfo2';
import { getUserRole } from '../../../Lib/helpers';
import { ROUTES } from '../../../Lib/constants';

const HeaderButtonIcon = (props) => {
  const {
    icon, message, onClick, tooltipId, imageStyle,
  } = props;
  return (
    <IconButton
      customStyle={{ marginLeft: 10, marginRight: 10 }}
      onClick={onClick}
      description={message}
      tooltipId={tooltipId}
      icon={icon}
      label="Change Password"
      labelStyle={{
        fontSize: 18,
        color: '#ffffff',
        fontFamily: 'Mulish-SemiBold',
      }}
      imageStyle={imageStyle}
    />
  );
};

const InventoryStatus = () => {
  const [dealerData, setDealerData] = useState({
    bulkCalls: '',
    setupState: '',
  });

  const user = getUser();
  const userRole = getUserRole();
  const dealerId = useMemo(() => user?.dealer?._id, [user]);
  console.log("Login User", user)

  useEffect(() => {
    const fetchData = async () => {
      if (userRole === 'dealer' || userRole === 'superdealer') {
        const { result } = await invoke({
          id: 'allDataOfDealer',
          paramValue: { dealerId },
        });
        setDealerData(result);
      }
    };

    fetchData();
  }, [dealerId, userRole]);

  if (userRole === 'dealer' || userRole === 'superdealer') {
    if (
      dealerData?.bulkCalls === 'Pending'
      && dealerData?.setupState === 'Complete'
    ) {
      return (
        <View
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
          }}
        >
          <View style={{ width: 50 }}>
            <ActivityIndicator
              size={20}
              width={3}
              theme={{
                containerStyle: {
                  overflow: undefined,
                  position: 'absolute',
                  left: 0,
                  top: 0,
                  right: 0,
                  bottom: 0,
                  alignItems: 'center',
                  justifyContent: 'center',
                  zIndex: 11,
                },
                animationStyle: {
                  width: 40,
                  height: 40,
                  borderWidth: 4,
                  borderColor: 'green',
                  borderRightColor: 'transparent',
                  borderRadius: '50%',
                  animationName: 'spinnerRotate',
                  animationDuration: '0.75s',
                  animationIterationCount: 'infinite',
                  animationTimingFunction: 'linear',
                },
              }}
            />
          </View>
          {/* <Image source={warningIcon} style={{ width: 20, height: 20 }} />{' '} */}
          <Text style={{ paddingTop: 4, color: 'green', fontSize: 15 }}>
            Inventory generation in progress. Repair orders will be available
            once inventory generation is finished.
          </Text>
        </View>
      );
    }
    return '';
  }
  return '';
};

const Header = (props) => {
  const {
    user, state, hide, navigation,
  } = props;
  const [fromSA, setFromSA] = useState(false);
  const [fromSD, setFromSD] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      Storage.getItem('tokenExpiryTime').then((tokenExpiryTime) => {
        const currentDate = new Date();
        const tokenExpiryDate = new Date(parseInt(tokenExpiryTime, 10));
        const diffTimeInMinutes = (tokenExpiryDate - currentDate) / (1000 * 60);

        if (diffTimeInMinutes < 5 && diffTimeInMinutes > 0) {
          refreshUserToken();
        }
      });
    }, 1000 * 30);

    return () => clearInterval(interval);
  }, []);

  if (!user || user.enforceChangePassword) {
    return <View />;
  }

  const viewsArray = state.views;
  const isHeaderActionsPresent = typeof viewsArray[viewsArray.length - 1].view.headerActions !== 'undefined';
  const logoutButtonFunction = async () => {
    await logout().then(() => {
      window.location.replace('/');
    });
  };

  Storage.getItem('fromSuperAdmin').then((res) => {
    if (res === 'true') {
      setFromSA(true);
    } else {
      setFromSA(false);
    }
  });

  Storage.getItem('fromSuperDealer').then((res) => {
    if (res) {
      setFromSD(res);
    } else {
      setFromSD(false);
    }
  });

  const loginAsSuperAdmin = async () => {
    const fromBackend = await invoke({
      id: 'loginAsSuperAdmin',
    });

    if (fromBackend.user.enforceChangePassword) {
      Toast.show({
        message:
          "Can't Login As Super Admin. Please Logout and Login as Super Admin!",
        type: 'warning',
        direction: 'left',
        position: 'top',
      });
    } else {
      navigation.reset(ROUTES.WelcomeSA.name);
      setUser(fromBackend.user);
      Storage.setItem('refreshToken', fromBackend.refreshToken);
      Storage.setItem('tokenExpiryTime', fromBackend.tokenExpiryTime);
      Storage.setItem('token', fromBackend.token);
      Storage.removeItem('fromSuperAdmin');
      window.location.reload();
    }
  };

  const loginAsSuperDealer = async () => {
  
    const fromBackend = await invoke({
      id: 'loginAsThisDealer',
      paramValue: { item: { username: fromSD } },
    });
  
    if (fromBackend.user.enforceChangePassword) {
      Toast.show({
        message:
          "Can't Login As Super Dealer. Please Logout and Login as Super Dealer!",
        type: 'warning',
        direction: 'left',
        position: 'top',
      });
    } else {
      navigation.reset(ROUTES.WelcomeDealer.name);
      setUser(fromBackend.user);
      Storage.setItem('refreshToken', fromBackend.refreshToken);
      Storage.setItem('tokenExpiryTime', fromBackend.tokenExpiryTime);
      Storage.setItem('token', fromBackend.token);
      Storage.removeItem('fromSuperAdmin');
      Storage.removeItem('fromSuperDealer');
      window.location.reload();
    }
  };

  return (
    <>
      {hide ? null : (
        <View className="noNeedToPrint" style={headerTheme.boxToHoldEverything}>
          <View style={headerTheme.boxToHoldLeftSide}>
            <View style={headerTheme.boxToHoldDashboardTitle}>
              <InventoryStatus />
            </View>
            {user?.dealer?.username && 
            <div className="mt-5 mt-md-0" style={{fontSize: "1.5rem", fontWeight: 500}}>
            <b>
              Dealer: {user?.dealer?.username}
            </b>
            </div>
            }
          </View>
          <View style={headerTheme.boxToHoldRightSide}>
            <View style={headerTheme.boxToHoldIcon}>
              <UserInfo2 {...props} />
            </View>
            <HeaderButtonIcon
              icon={powerIcon}
              message="Logout"
              tooltipId="Logoutbutton"
              onClick={logoutButtonFunction}
            />

            {fromSA && !fromSD && (
              <HeaderButtonIcon
                icon={loginAsThisDealer}
                message="Login As Superadmin"
                tooltipId="Login As Superadmin"
                onClick={loginAsSuperAdmin}
                imageStyle={{ transform: 'rotateZ(180deg)' }}
              />
            )}
            {
            fromSD && (
              <HeaderButtonIcon
                icon={loginAsThisDealer}
                message="Login As Super Dealer"
                tooltipId="Login As Super Dealer"
                onClick={loginAsSuperDealer}
                imageStyle={{ transform: 'rotateZ(180deg)' }}
              />
            )}
            
          </View>
        </View>
      )}
      {isHeaderActionsPresent ? (
        <View
          className="noNeedToPrint"
          style={headerTheme.boxToHoldHeaderActions}
        >
          <ScreenHeaderActions {...props} />
        </View>
      ) : null}
    </>
  );
};

export default Header;
